import { clientBase } from "../common";

export const postRequestMentoryUser = (_body) => {
  return clientBase(`v2/mentory-user`, "POST", {
    body: _body,
  });
};

export const getItems = (_id) => {
  return clientBase(`v2/mentory-available/${_id}`, "get");
};

export const postCancelMentoryUser = (_body) => {
  return clientBase(`v2/mentory-user/cancel-mentory`, "POST", {
    body: _body,
  });
};